import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0462. 取引先削除
 * [DELETE] /workspaces/:identifier/business_partners/:id
 */
type Props = {
  identifier: string;
  id: number;
};
export const destroyBusinessPartner = (props: Props): Promise<any> => {
  return axios.delete(`/api/workspaces/${props.identifier}/business_partners/${props.id}`);
};

export const useDestroyBusinessPartner = () => {
  return useMutation({
    mutationFn: destroyBusinessPartner,
  });
};
